import Users from "../../Users/Users";

// This page previously had its own mocked user list/dialog instead of real data.
// Reuse the real Users module here so Settings > Users shows and manages the
// actual users of the currently active agency (with add/edit, change admin, etc.)
export default function UserPage() {
  return <Users />;
}
